import Vue from 'vue'
import Router from 'vue-router'
import Header from '@/components/pageComponents/Header'
import Aside from '@/components/pageComponents/Aside'
import Login from '@/components/Login'
import UserManagement from '@/components/UserManagement'
import UserAddOrEditUser from '@/components/UserAddOrEditUser'
import UserDetailPrepay from '@/components/UserDetailPrepay'
import UserDetailAfterpay from '@/components/UserDetailAfterpay'
import RechargePagePrepay from '@/components/RechargePagePrepay'
import RechargePageAfterpay from '@/components/RechargePageAfterpay'
import PermissionAssignment from '@/components/PermissionAssignment'
import PermissionDetailPrepay from '@/components/PermissionDetailPrepay'
import PermissionDetailAfterpay from '@/components/PermissionDetailAfterpay'
import AfterpayBillPage from '@/components/AfterpayBillPage'
import HistoricalBill from '@/components/HistoricalBill'
import ChargingManagement from '@/components/ChargingManagement'
import ChargingDetailPrepay from '@/components/ChargingDetailPrepay'
import ChargingDetailAfterpay from '@/components/ChargingDetailAfterpay'
import InterfaceCallDetail from '@/components/InterfaceCallDetail'
import DataServiceManagement from '@/components/DataServiceManagement'
import SystemSettings from '@/components/SystemSettings'

import DataScreening from '@/components/DataScreening'

Vue.use(Router)
const router = new Router({
  mode: 'hash',
  base: '/',
  routes: [
    {
      path: '/qxfp',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: PermissionAssignment
      },
      meta: {
        title: '权限分配',
        isLogin: true
      }
    },
    {
      path: '/jfgl',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: ChargingManagement
      },
      meta: {
        title: '计费管理',
        isLogin: true
      }
    },
    {
      path: '/yhgl',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: UserManagement
      },
      meta: {
        title: '用户管理',
        isLogin: true
      }
    },
    {
      path: '/xtsz',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: SystemSettings
      },
      meta: {
        title: '系统设置',
        isLogin: true
      }
    },
    {
      path: '/tjbjyh',
      name: 'userAddOrEditUser',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: UserAddOrEditUser
      },
      meta: {
        title: '用户管理',
        isLogin: true
      }
    },
    {
      path: '/PermissionDetailPrepay',
      name: 'PermissionDetailPrepay',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: PermissionDetailPrepay
      },
      meta: {
        title: '权限详情',
        isLogin: true
      }
    },
    {
      path: '/PermissionDetailAfterpay',
      name: 'PermissionDetailAfterpay',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: PermissionDetailAfterpay
      },
      meta: {
        title: '权限详情',
        isLogin: true
      }
    },
    {
      path: '/AfterpayBillPage',
      name: 'AfterpayBillPage',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: AfterpayBillPage
      },
      meta: {
        title: '账单详情',
        isLogin: true
      }
    },
    {
      path: '/HistoricalBill',
      name: 'HistoricalBill',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: HistoricalBill
      },
      meta: {
        title: '历史账单',
        isLogin: true
      }
    },
    
    {
      path: '/ChargingDetailPrepay',
      name: 'ChargingDetailPrepay',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: ChargingDetailPrepay
      },
      meta: {
        title: '计费详情',
        isLogin: true
      }
    },
    {
      path: '/ChargingDetailAfterpay',
      name: 'ChargingDetailAfterpay',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: ChargingDetailAfterpay
      },
      meta: {
        title: '计费详情',
        isLogin: true
      }
    },
    {
      path: '/jkdyxq',
      name: 'InterfaceCallDetail',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: InterfaceCallDetail
      },
      meta: {
        title: '接口调用详情',
        isLogin: true
      }
    },
    {
      path: '/RechargePagePrepay',
      name: 'RechargePagePrepay',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: RechargePagePrepay
      },
      meta: {
        title: '充值',
        isLogin: true
      }
    },
    {
      path: '/RechargePageAfterpay',
      name: 'RechargePageAfterpay',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: RechargePageAfterpay
      },
      meta: {
        title: '后付费',
        isLogin: true
      }
    },
    {
      path: '/UserDetailPrepay',
      name: 'UserDetailPrepay',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: UserDetailPrepay
      },
      meta: {
        title: '用户详情',
        isLogin: true
      }
    },
    {
      path: '/UserDetailAfterpay',
      name: 'UserDetailAfterpay',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: UserDetailAfterpay
      },
      meta: {
        title: '用户详情',
        isLogin: true
      }
    },
    {
      path: '/',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: DataServiceManagement
      },
      meta: {
        title: '数据服务管理',
        isLogin: true
      }
    },
    {
      path: '/sjzl',
      components: {
        headerPage: Header,
        asidePage: Aside,
        mainPage: DataScreening
      },
      meta: {
        title: '数据总览',
        isLogin: true
      }
    },
    {
      path: '/login',
      components: {
        mainPage: Login
      },
      meta: {
        title: '登录',
        isLogin: false,
        isShowHeader: false
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else {
    let token = localStorage.getItem('Authorization')
    if (token === null || token === '' || token === undefined) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js